export const extractButtonsHtml = (body) => {
  const buttons = body.match(/<a.*?href=".*?">.*?<\/a>/g) || [];
  let isFirstButton = true;

  return buttons
    .map((button) => {
      if (isFirstButton) {
        isFirstButton = false;
        return button
          .replace(/style=".*?"/g, "")
          .replace(
            /<a(.*?)>/,
            `<a$1 style="background: grey; color: #ffffff; text-decoration: none; display: inline-block; font-size: 15.75px; cursor: pointer; padding: 7.5px 40px;">`
          );
      }
      return button
        .replace(/style=".*?"/g, "")
        .replace(
          /<a(.*?)>/,
          `<a$1 style="background: #feba02; color: #011842; text-decoration: none; display: inline-block; font-size: 15.75px; cursor: pointer; padding: 7.5px 40px;">`
        );
    })
    .join("\n");
};
export const addInlineStylesToTags = (content) => {
  // Function to add inline style based on class name
  const addStyleToClass = (tagName, className, alignment) => {
    const regex = new RegExp(
      `<${tagName}([^>]*)class="([^"]*${className}[^"]*)"(.*?)>`,
      "g"
    );
    return content?.replace(regex, (match, beforeClass, classNames, after) => {
      // Check if style attribute already exists
      const styleMatch = beforeClass.match(/style="([^"]*)"/);
      const existingStyle = styleMatch ? styleMatch[1] : "";
      const newStyle = existingStyle
        ? `${existingStyle}; text-align: ${alignment}`
        : `text-align: ${alignment}`;

      // Return the updated tag with the new style
      if (styleMatch) {
        return `<${tagName}${beforeClass.replace(
          /style="[^"]*"/,
          `style="${newStyle}"`
        )} class="${classNames}"${after}>`;
      } else {
        return `<${tagName}${beforeClass} style="${newStyle}" class="${classNames}"${after}>`;
      }
    });
  };
  content = addStyleToClass("p", "ql-align-center", "center");
  content = addStyleToClass("p", "ql-align-left", "left");
  content = addStyleToClass("p", "ql-align-right", "right");

  content = addStyleToClass("h1", "ql-align-center", "center");
  content = addStyleToClass("h2", "ql-align-center", "center");
  content = addStyleToClass("h3", "ql-align-center", "center");
  content = addStyleToClass("h4", "ql-align-center", "center");
  content = addStyleToClass("h5", "ql-align-center", "center");
  content = addStyleToClass("h6", "ql-align-center", "center");

  content = addStyleToClass("h1", "ql-align-left", "left");
  content = addStyleToClass("h2", "ql-align-left", "left");
  content = addStyleToClass("h3", "ql-align-left", "left");
  content = addStyleToClass("h4", "ql-align-left", "left");
  content = addStyleToClass("h5", "ql-align-left", "left");
  content = addStyleToClass("h6", "ql-align-left", "left");

  content = addStyleToClass("h1", "ql-align-right", "right");
  content = addStyleToClass("h2", "ql-align-right", "right");
  content = addStyleToClass("h3", "ql-align-right", "right");
  content = addStyleToClass("h4", "ql-align-right", "right");
  content = addStyleToClass("h5", "ql-align-right", "right");
  content = addStyleToClass("h6", "ql-align-right", "right");
  return content;
};

export const sanitizeQuillContentEndOnly = (content) => {
  console.log(content, "content-before");
  content = content.replace(
    /<p>\s*<br\s*\/?>\s*<\/p>/g,
    '<p class="explicit_line_spacing"></p>'
  );
  content = content.replace(/(<br\s*\/?>\s*)+$/g, "");
  content = content.replace(/(<p[^>]*>\s*(<br\s*\/?>|\s)*<\/p>\s*)+$/g, "");
  console.log(content.trim(), "content-after");
  content = addInlineStylesToTags(content);
  return content.trim();
};
export const generateFinalText = (text, removedButtons) => {
  const finalText = `
    <body style="margin: 0px auto; 
        max-width: 800px; 
        word-break: break-word; 
        padding: 5px; 
        -webkit-text-size-adjust: 100%; 
        -ms-text-size-adjust: 100%;">
      <div style="margin: 10px;  max-width: 790px;">
        ${sanitizeQuillContentEndOnly(text)}
        <div style="text-align: center; margin-top: 35px;">
          ${removedButtons}
        </div>
      </div>
    </body>
  `;
  return btoa(unescape(encodeURIComponent(finalText)));
};
export const generateFinalTextWithoutButtons = (text) => {
  const finalText = `
    <body style="margin: 0px auto; 
        max-width: 800px; 
        word-break: break-word; 
        padding: 5px; 
        -webkit-text-size-adjust: 100%; 
        -ms-text-size-adjust: 100%;">
      <div style="margin: 10px;  max-width: 790px;">
        ${sanitizeQuillContentEndOnly(text)}
      </div>
    </body>
  `;
  return btoa(unescape(encodeURIComponent(finalText)));
};
export const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    [{ align: [] }],
    ["bold", "italic"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ color: [] }, { background: [] }],
    ["link"],
    ["clean"],
  ],
};

export const quillModulesUser = {
  toolbar: [["clean"]],
};
